import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'
import { Parameter } from '../script/parameter.js'
import { BoVisitor } from './bo-visitor.js'
import { assignCommonProperties } from '../util/data/assign-common-properties.js'

@jsonClass('Actionable')
export class Actionable {
	@jsonProperty(String) name!: string
	@jsonArrayProperty(Parameter) inputs: Parameter[] = []
	@jsonProperty(String) code: string = ''

	constructor(init?: Partial<Actionable>) {
		assignCommonProperties(this, init)
	}

	visit(visitor: BoVisitor, pathPrefix: (string | number)[]): void {
		visitor.visitTsCode(
			this.code,
			this,
			'action',
			[...pathPrefix, 'code'],
			(newCode) => (this.code = newCode),
		)
		this.inputs.forEach((input, idx) =>
			input.visit(visitor, [...pathPrefix, 'inputs', idx]),
		)
	}
}
